export default __webpack_public_path__ + "static/media/black.27282153.png";